import type { Directive } from 'vue';

/**
 * v-img-hide-on-error — masque l'<img> (display:none) si son chargement échoue.
 * Remplace le handler inline `@error="(e) => ((e.target as HTMLImageElement)
 * .style.display = 'none')"` répété dans ~23 composants.
 *
 *   <img :src="url" v-img-hide-on-error />
 *
 * Pour un repli vers une autre image (vaisseaux, etc.), utiliser plutôt un
 * handler @error dédié (cf utils/assetUrl.onShipImgError).
 */
export const vImgHideOnError: Directive<HTMLImageElement> = {
  mounted(el) {
    el.addEventListener('error', () => { el.style.display = 'none'; });
  },
};
